/**
 * Central runtime configuration.
 *
 * All environment variables MUST be set in the deployment environment.
 * Hardcoded fallbacks are intentionally removed to prevent silent misconfiguration.
 *
 * Required env vars:
 *   VITE_API_URL          – Backend API base URL (e.g. https://sineapi-production-8db6.up.railway.app)
 *   VITE_SUPABASE_URL     – Supabase project URL
 *   VITE_SUPABASE_ANON_KEY – Supabase anon/public key
 */

function requireEnv(key: string): string {
  const value = (import.meta.env as Record<string, string | undefined>)[key]
  if (!value) {
    // Warn loudly in all environments but don't throw — a hard throw produces
    // a blank white screen with no context. A console.error + empty string lets
    // the app render and show a proper "configuration error" UI instead.
    console.error(
      `[config] Missing required environment variable: ${key}.`,
      import.meta.env.DEV
        ? 'Set it in .env.local'
        : 'Set it as a Railway Variable (VITE_* vars must be present at Docker build time).'
    )
    return ''
  }
  return value
}

export const API_BASE = requireEnv('VITE_API_URL')
export const SUPABASE_URL = requireEnv('VITE_SUPABASE_URL')
export const SUPABASE_ANON_KEY = requireEnv('VITE_SUPABASE_ANON_KEY')
